export default __webpack_public_path__ + "static/console_owner-65861c301a8a56671c2e263c04f45e77.jpg";